module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_19",
      "title": "19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("PART 1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Title-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("CURIOUS CHILD")])])]), _vm._v(" "), _c('p', {
    staticClass: "PGBREAK"
  }), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-No-Indent-potx1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_21",
      "title": "21"
    }
  }, [_vm._v("Do I believe in redemption?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I suppose I must. For how can I forgive myself my own sins if not in the belief that I can, and must, atone? Are my crimes so monstrous that I can never return the balance of justice? So heinous that no matter what I do with the rest of my life, I will never lie in peace on my deathbed confident that in the end I left this world a better place than I found it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I can only shrug, for that is not for me to judge, nor is it why I believe in redemption, nor is it, in the end, the measure of redemption. For such reparation is first and foremost an internal truth, a realization toward the proper and just course.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You told me of Brother Francis, so long a thrall to the evil Father Abbot Markwart, who was responsible for the death of your own brother, Grady. You spoke of how Francis, in the end, found repentance in tending to the suffering peasants who had been caught by the rosie plague. Francis, this man, your enemy, gave his life in service to them, willingly, joyously, because he found the light of goodness and it swelled his heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And in the end, in the moment of his death, you stood with him and felt generosity in your heart, and felt sadness at his passing. And against your own anger in his last revelations of his part in the death of Grady, you threw aside your pain and anger and forgave him, and even wanted to save him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("How can I know the tale of Jilseponie and Brother Francis and not believe in redemption?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("So many times since my defeat and exile have I been told that I was tainted in the womb, that the demon dactyl, in battling my mother, had found a way to paint my heart with its darkness. I do not doubt that there is some truth to this, for those who have made the claim, from Lady Dasslerond of the Touel’alfar to my mother herself, who lies forever still beneath this freshly tilled ground, knew well the evils of her great foe.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("But the demon I harbored from my past, the stain of Bestesbulzibar that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_22",
      "title": "22"
    }
  }, [_vm._v("infected my soul when I was a babe in the womb, is no excuse. The dark influences that weighed upon me, whether by Marcalo De’Unnero or the dactyl demon itself, do not exempt me from blame, do not diminish the truth that it was I, Aydrian, who ultimately made the choices. It was I who exacted suffering upon others for the sake of personal gain and glory.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We are not trapped by heritage or by childhood. When we come of age and discover the ability to see the world as it is around us, the choices we make, whatever our demons, are our own.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The love my mother held for me was lasting and generous, and so many times those who love us will offer such excuses, blaming friends and peers for taking us down a dangerous and dark path.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No, I say.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Simply no.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I reject your excuses, beloved mother, even as I weep for losing you. Whether or not the demon dactyl did as you believed, and so cursed me with blackness in my heart, I long ago accepted the responsibility for my actions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("That acceptance has not broken me—far from it! And that darkness, whatever its root, does not remain within the heart of Aydrian Wyndon. I have passed my third decade of life now, my heart is clear, my mind uncluttered, my course vivid in my mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I believe in redemption, but only because I believe that I must redeem myself. Not for any personal gain, not even for some ephemeral concept of honor—except as doing so would honor you, and Elbryan my father, and the work you both undertook and the good you both accomplished.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I have forgiven myself and dismissed my shame at my failures, and the dark reflection I cast upon Elbryan and Jilseponie, the heroes of Honce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("But only because I know that that darkness is now no more.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We cannot change our past, and denying it serves no good end. For changing how we speak about it might deceive others, but not ourselves. Those chapters are written, the words are clear, the ink dried. But the book is not complete so long as we draw breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("This, then, is my vow to you, Jilseponie, my mother. I will write better chapters.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Author-Signature-ausig"
  }, [_vm._v("Aydrian Wyndon, Jilseponie’s graveside eulogy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef8734c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 81
// module chunks = 0